import React from "react";
import Bredcom from "../Bredcom/Main";
import Header from "../headerone/Main";
import First from "../mencourses/First";
import Brand from "../menhomethree/Brand";
import CourseDetail from "../menhome/CourseDetail";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom title="Home" subtitle="Courses" />
        {/* <First/> */}
        <CourseDetail />
        {/* <Brand /> */}
      </section>
    </>
  );
}

export default Main;
